import React from 'react';
import { Helmet } from 'react-helmet';
import { Translation } from "react-i18next";
import BgWithText from '../../components/backgroundWithText/BgWithText';
import Image from "../../components/image";
import { asset } from '../../helpers/dom.helper';
import { Media, MediaContextProvider } from '../../media';
import Benefits from './components/Benefits';
import JobOpening from './components/JobOpening';
import './styles/styles.css';

export default class CareerList extends React.Component {

  render() {
    return (
      <Translation ns={['translation', 'career']}>
        {t => (
          <>
            <Helmet>
              <title>{t('career:title')}</title>
              <meta name="description" content={t('career:metaDescription')} />
              <meta name="keywords" content={t('career:metaKeyword')} />
              <link rel="canonical" href="https://silverman.app/career" />
            </Helmet>

            <MediaContextProvider>
              <Media lessThan="md">
                <BgWithText
                  data={{
                    title: t('career:title'),
                    subtitle: t('career:We greatly believe that human resources is the most valuable asset. At Silverman, we provide endless opportunities to unfold your skills and overcome your limits.')
                  }}
                  image={asset('/images/career/bg_image-mobile.webp')}
                  height={350}
                />
              </Media>
              <Media greaterThanOrEqual="md">
                <BgWithText
                  data={{
                    title: t('career:title'),
                    subtitle: t('career:We greatly believe that human resources is the most valuable asset. At Silverman, we provide endless opportunities to unfold your skills and overcome your limits.')
                  }}
                  image={asset('/images/career/bg_image.webp')}
                  height={350}
                />
              </Media>
            </MediaContextProvider>

            <div className="career__image_content_container">
              <div className="career__image_container">
                <Image src={asset('/images/career/man_suit.webp')} alt="man in suit" className="career__image" />
              </div>
              <div className="career__content_container">
                <p className="career__content_title">{t('career:WHY SILVERMAN?')}</p>
                <p className="career__content_subtitle">{t('career:Working at Silverman is more than just a job. You can make a difference in the quality of lives of millions of residents in the world by our platforms and explore your passions with the coolest innovative property management technology.')}</p>
              </div>
            </div>

            <div className="career_benefits_bg" style={{ backgroundImage: `url(${asset('/images/career/benefits_bg.webp')})` }}>
              <Benefits title={t('career:4 Competitive Benefits')} data={t('career:benefits:benefit_list', { returnObjects: true })} />
            </div>

            <JobOpening />

            <br />
            <br />
          </>
        )}
      </Translation>
    )
  }

}

